/* Re-sync nudge 2026-08-13T16:45Z */
/* NEW-variant-selector.js
   Shared handler for the .new-vsel image-led variant selector component.
   Responsibilities:
     - Option click → update is-selected / is-unavailable states
     - Find the matching Shopify variant from the embedded variants JSON
     - Dispatch new:variant-selected on the nearest form (bubbles to PDP root)
     - Dispatch new:media-selected on the PDP root for gallery switching
   Per-PDP JS files (NEW-accessories-pdp.js, NEW-treatment-pdp.js, etc.)
   listen to new:variant-selected to update price, ATC, Klarna, etc. */

(function () {
  'use strict';

  function initVsel(container) {
    /* Idempotency guard — the script may be included by both a section and a
       snippet (live theme sync can lag on individual files); init only once. */
    if (container.dataset.vselInit) return;
    container.dataset.vselInit = '1';

    var jsonEl = container.querySelector('[data-variants-json]');
    if (!jsonEl) return;
    var variants = [];
    try { variants = JSON.parse(jsonEl.textContent); } catch (e) { return; }

    var mediaMap = {};
    var mediaMapEl = container.querySelector('[data-variant-media-map]');
    if (mediaMapEl) {
      try { mediaMap = JSON.parse(mediaMapEl.textContent); } catch (e) {}
    }

    var groups = Array.from(container.querySelectorAll('[data-option-group]'));
    var optionCount = groups.length;

    /* Seed selected[] from the is-selected buttons rendered by Liquid. */
    var selected = {};
    groups.forEach(function (group) {
      var idx = parseInt(group.dataset.optionIndex, 10);
      var active = group.querySelector('.new-vsel__row.is-selected');
      if (active) selected[idx] = active.dataset.optionValue;
    });

    function findVariant() {
      /* Prefer an available exact match; fall back to any exact match. */
      var avail = variants.find(function (v) {
        if (!v.available) return false;
        for (var i = 0; i < optionCount; i++) {
          if (selected[i] !== v['option' + (i + 1)]) return false;
        }
        return true;
      });
      if (avail) return avail;
      return variants.find(function (v) {
        for (var i = 0; i < optionCount; i++) {
          if (selected[i] !== v['option' + (i + 1)]) return false;
        }
        return true;
      });
    }

    function isValueAvailable(optIdx, value) {
      return variants.some(function (v) {
        if (!v.available) return false;
        if (v['option' + (optIdx + 1)] !== value) return false;
        for (var i = 0; i < optionCount; i++) {
          if (i === optIdx) continue;
          if (selected[i] != null && v['option' + (i + 1)] !== selected[i]) return false;
        }
        return true;
      });
    }

    function refreshAvailability() {
      groups.forEach(function (group) {
        var optIdx = parseInt(group.dataset.optionIndex, 10);
        group.querySelectorAll('.new-vsel__row').forEach(function (btn) {
          if (btn.classList.contains('is-selected')) return;
          var avail = isValueAvailable(optIdx, btn.dataset.optionValue);
          btn.classList.toggle('is-unavailable', !avail);
          if (!avail) btn.setAttribute('aria-disabled', 'true');
          else btn.removeAttribute('aria-disabled');
        });
      });
    }

    container.addEventListener('click', function (e) {
      var btn = e.target.closest('.new-vsel__row');
      if (!btn || btn.classList.contains('is-unavailable')) return;

      var optIdx = parseInt(btn.dataset.optionIndex, 10);
      selected[optIdx] = btn.dataset.optionValue;

      /* Mark selected within this group. */
      var group = groups.find(function (g) {
        return parseInt(g.dataset.optionIndex, 10) === optIdx;
      });
      if (group) {
        group.querySelectorAll('.new-vsel__row').forEach(function (b) {
          var on = b === btn;
          b.classList.toggle('is-selected', on);
          b.setAttribute('aria-checked', on ? 'true' : 'false');
        });
      }

      /* Persist current selections on the container. */
      var opts = [];
      for (var i = 0; i < optionCount; i++) opts.push(selected[i] || '');
      container.dataset.currentOptions = JSON.stringify(opts);

      refreshAvailability();

      var v = findVariant();
      if (!v) return;

      /* Gallery switch — the per-PDP gallery JS listens for new:media-selected. */
      var mediaId = mediaMap[String(v.id)];
      if (mediaId) {
        var pdpRoot = container.closest('[class*="-pdp"]') || document.body;
        pdpRoot.dispatchEvent(new CustomEvent('new:media-selected', {
          bubbles: true,
          detail: { mediaId: mediaId }
        }));
      }

      /* Variant selected — per-PDP JS handles price/ATC/Klarna/SK/subscribe updates. */
      var form = container.closest('form');
      var target = form || container;
      target.dispatchEvent(new CustomEvent('new:variant-selected', {
        bubbles: true,
        detail: { variantId: v.id, variant: v }
      }));
    });

    refreshAvailability();

    /* Fire an initial new:variant-selected so per-PDP JS and the legacy bridge
       can enable the ATC button on page load without waiting for a user click.
       setTimeout(0) defers one tick so all per-PDP listeners are attached. */
    setTimeout(function () {
      var v = findVariant();
      if (!v) return;

      var mediaId = mediaMap[String(v.id)];
      if (mediaId) {
        var pdpRoot = container.closest('[class*="-pdp"]') || document.body;
        pdpRoot.dispatchEvent(new CustomEvent('new:media-selected', {
          bubbles: true,
          detail: { mediaId: mediaId }
        }));
      }

      var form = container.closest('form');
      var target = form || container;
      target.dispatchEvent(new CustomEvent('new:variant-selected', {
        bubbles: true,
        detail: { variantId: v.id, variant: v }
      }));
    }, 0);
  }

  function boot() {
    document.querySelectorAll('[data-vsel]').forEach(initVsel);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();

/* ── Klarna OSM price sync loader (alternate path) ────────────────────────
   Same loader as in the NEW-*-pdp.js files; lives here too because this file
   is self-loaded on pre-glued PDPs and its GitHub→Shopify sync is reliable.
   Idempotent: guards prevent double-loading NEW-klarna-sync.js. */
(function () {
  if (window.__nkKlarnaSyncV3 || document.querySelector('script[src*="NEW-klarna-sync"]')) return;
  var self = document.querySelector('script[src*="NEW-variant-selector"]');
  if (!self || !self.src) return;
  var s = document.createElement('script');
  s.src = self.src.replace(/NEW-variant-selector\.js[^"']*$/, 'NEW-klarna-sync.js');
  document.head.appendChild(s);
})();
